import newsPostIcon from "@assets/logo-newspost.svg";
import { cn } from "@util/helpers";

import { ArticlePurchaseLinkProps } from "./types";

export default function ArticlePurchaseLinkVersion1({
  title,
  publishedDate,
  rootTextClassName,
}: ArticlePurchaseLinkProps): React.ReactElement {
  const date = encodeURIComponent(publishedDate);
  const encodedTitle = encodeURIComponent(title);

  return (
    <section
      className="mx-auto my-4 w-full"
      data-testid="article-purchase-link-version-1-component"
    >
      <a
        className={cn(
          "flex items-center justify-between font-poppins font-semibold hover:underline",
          rootTextClassName
        )}
        href={`https://newspost.newslink.sg/?publication=BT&date=${date}&title=${encodedTitle}`}
        target="_blank"
        rel="noreferrer"
      >
        <span>Purchase this article</span>
        <img src={newsPostIcon} alt="newspaper icon" />
      </a>
    </section>
  );
}
